export default __webpack_public_path__ + "static/media/annex2.f8bb8651.png";